import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full px-6 py-12 md:py-20 flex flex-col items-center text-center bg-cream" data-id="element-20">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-reading mx-auto" data-id="element-21">
        <span className="text-sm tracking-widest uppercase text-brown/60 mb-8 block font-medium" data-id="element-22">
          Bebé Sin Derrumbe
        </span>

        <h1 className="text-4xl md:text-5xl lg:text-6xl text-brown leading-[1.1] mb-12" data-id="element-23">
          No estás desorganizada: <br className="hidden md:block" data-id="element-24" />
          <span className="italic text-ochre" data-id="element-25">estás cargando sola.</span>
        </h1>

        <div className="space-y-6 text-lg md:text-xl text-brown/90 leading-relaxed text-left md:text-center font-light" data-id="element-26">
          <p data-id="element-27">Hay un tipo de cansancio que no se arregla con una siesta.</p>
          <p data-id="element-28">Es el cansancio de ser la persona que se acuerda de todo.</p>
          <p className="font-medium text-brown" data-id="element-29">
            Pañales. Citas. Ropa. Botiquín. Siestas. Bolsa de salida. Compras.
          </p>
          <p data-id="element-30">Y encima… explicar. Pedir. Recordar. Corregir. Volver a pedir.</p>
          <p data-id="element-31">Y cuando por fin dices "necesito ayuda", te contestan:</p>
          <p className="italic text-brown/80" data-id="element-32">"Ok, solo dime qué hago."</p>
          <div className="pt-4" data-id="element-33">
            <p data-id="element-34">En ese instante no te enojas por la frase.</p>
            <p className="text-xl md:text-2xl font-serif text-brown mt-2" data-id="element-35">
              Te enojas porque entiendes algo terrible:
            </p>
            <p className="text-xl md:text-2xl font-serif text-ochre italic mt-1" data-id="element-36">
              Si tú tienes que decirlo, todavía es tuyo.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}